var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportCsvOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 80,
    viewBox: "0 0 109 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 80,
    rx: 4,
    fill: "#F6F8FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 15,
    width: 47,
    height: 4,
    rx: 2,
    fill: "#DAE0E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 52,
    width: 89,
    height: 4,
    rx: 2,
    fill: "#DAE0E8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 62,
    width: 89,
    height: 4,
    rx: 2,
    fill: "#DAE0E8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 25,
    width: 25,
    height: 4,
    rx: 2,
    fill: "#DAE0E8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 24,
    r: 16,
    fill: "#DAE0E8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 35,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7989 40.2416C32.195 39.0861 35.8053 39.0861 39.2015 40.2416C39.5283 40.3528 39.703 40.7079 39.5919 41.0347C39.4807 41.3614 39.1256 41.5362 38.7989 41.425C35.6637 40.3583 32.3366 40.3583 29.2015 41.425C28.8747 41.5362 28.5197 41.3614 28.4085 41.0347C28.2973 40.7079 28.4721 40.3528 28.7989 40.2416Z",
    fill: "#5964FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9171 29.7439C28.1563 29.507 28.4794 29.375 28.8151 29.375H39.1855C39.5212 29.375 39.8444 29.507 40.0836 29.7439C40.323 29.981 40.4587 30.3039 40.4587 30.6418V37.0603C40.4587 37.3983 40.323 37.7212 40.0836 37.9583C39.8444 38.1952 39.5212 38.3272 39.1855 38.3272H35.9216V40C35.9216 40.1738 35.8492 40.3398 35.7219 40.458C35.5945 40.5763 35.4236 40.6362 35.2503 40.6233C34.4181 40.5614 33.5825 40.5614 32.7504 40.6233C32.5771 40.6362 32.4062 40.5763 32.2788 40.458C32.1514 40.3398 32.079 40.1738 32.079 40V38.3272H28.8151C28.4794 38.3272 28.1563 38.1952 27.9171 37.9583C27.6776 37.7212 27.542 37.3983 27.542 37.0603V30.6418C27.542 30.3039 27.6776 29.981 27.9171 29.7439ZM39.1855 37.0772C39.1936 37.0772 39.2002 37.0739 39.204 37.0701C39.2077 37.0665 39.2087 37.0628 39.2087 37.0603V30.6418C39.2087 30.6394 39.2077 30.6357 39.204 30.6321C39.2002 30.6282 39.1936 30.625 39.1855 30.625H28.8151C28.807 30.625 28.8005 30.6282 28.7966 30.6321C28.7929 30.6357 28.792 30.6394 28.792 30.6418V37.0603C28.792 37.0628 28.7929 37.0665 28.7966 37.0701C28.8005 37.0739 28.807 37.0772 28.8151 37.0772H39.1855ZM33.329 38.3272V39.3393C33.7764 39.3227 34.2242 39.3227 34.6716 39.3393V38.3272H33.329Z",
    fill: "#5964FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCsvOne);
export default __webpack_public_path__ + "static/media/import-csv-one.4f191198b9298dfdd622e688d2edd26d.svg";
export { ForwardRef as ReactComponent };